var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.177,
    height: 8.236,
    viewBox: "0 0 6.177 8.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    id: "Icon_awesome-map-marker-alt",
    "data-name": "Icon awesome-map-marker-alt",
    d: "M2.771,8.069C.434,4.681,0,4.334,0,3.088a3.088,3.088,0,0,1,6.177,0c0,1.245-.434,1.593-2.771,4.981a.386.386,0,0,1-.635,0Zm.317-3.694A1.287,1.287,0,1,0,1.8,3.088,1.287,1.287,0,0,0,3.088,4.375Z",
    fill: "rgba(0,0,0,0.64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpot);
export default __webpack_public_path__ + "static/media/icon-spot.80d244f6b93505c3561986aa6d9d6877.svg";
export { ForwardRef as ReactComponent };